module.exports = __webpack_public_path__ + "img/pic1.7a74cb5d.png";